export default [
  {
    text: "Desktop",
    value: "desktop",
  },
  {
    text: "Tablet",
    value: "tablet",
  },
  {
    text: "Smartphone",
    value: "smartphone",
  },
];
